<template>
  <div class="mb-pd-container">
    <div ref="wrapper" class="label-scroll">
      <div class="class-label">
        <div>
          <div class="class-item" :style="{'fontWeight':(activeLab==-1?600:'')}"  @click="toType(0)">
            全部
            <div class="l--l" v-if="activeLab==-1"></div>
          </div>
          <div class="class-item"  @click="toType(item.id)" :style="{'fontWeight':(activeLab==key?600:'')}"
               v-for="(item,key) in type" :key="key">{{item.typeName}}
            <div class="l--l" v-if="activeLab==key"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="default-pic" v-if="productInfo.length==0">
      <img src="../../assets/image/default.png"/>
      <div>暂无此类型 </div>
    </div>
    <div class="pd-content" v-else>
      <div class="pd-box" v-for="(item,key) in productInfo" :key="key" @click="toDetail(item.id,item.itemIntro)">
        <div class="pd-box-top">
          <div class="pd-title">{{item.itemName}}</div>
          <div class="more-btn"><p>more+</p></div>
        </div>
        <div class="pd-intro">{{item.itemIntro}}</div>
        <div class="pd-pic">
          <img :src="$img + item.itemMobileCover">
        </div>
      </div>
    </div>
    <mbFooter></mbFooter>
  </div>
</template>

<script>
  import mbFooter from "../../components/mobile/mbFooter"
  import BScroll from 'better-scroll'

  export default {
    components: {mbFooter},
    name: "mobile",
    data() {
      return {
        bscroll: {},
        activeLab: -1,
        productInfo: [],
        type:[]
      }
    },
    created() {
      this.$http.get('/api/item/type/list').then((res)=>{
        // console.log(res)
        this.type = res.data.rows
      })
      this.$http.get('/api/item/info/list').then((res)=>{
        this.productInfo = res.data.rows
      })
    },
    mounted() {
      this.activeLab = this.$store.state.activeLabMb
      // this.productInfo=productInfo.allInfo

      this.$nextTick(() => {
        let timer = setTimeout(() => {
          if (timer) {
            clearTimeout(timer)
            this.verScroll()
          }
        }, 0)
      })
    },
    methods: {
      // toType(id){
      //   console.log(id)
      //   //请求接口
      //   this.backTop()
      // },
      toType(id){
        if (id==0){
          this.$http.get('/api/item/info/list').then((res)=>{
            this.productInfo = res.data.rows
          })
        }else{
          console.log(id)
          this.$http.get('/api/item/info/list',{
            params:{
              itemTypeId:id
            }
          }).then((res)=>{
            console.log(res)
            this.productInfo = res.data.rows
            this.productInfo = res.data.rows
          })
        }
        this.$store.commit('editActiveLabMb',id-1)
        this.activeLab = this.$store.state.activeLabMb
        this.backTop()
      },
      toDetail(id,itemIntro) {    //跳转详情页
        this.$router.push({
          path: '/mobileProductDetail',
          query: {id,itemIntro}
        })
      },
      backTop(){  //返回顶部
        document.body.scrollTop=0
        document.documentElement.scrollTop=0
      },
      verScroll() {
        this.$nextTick(() => {
          this.scroll = new BScroll(this.$refs.wrapper, {
            startX: 0,
            click: true,
            scrollX: true,
            scrollY: false,
            eventPassthrough: 'vertical'
          })
        })
      },
      /*
      selectAll() {
        this.$store.commit('editActiveLabMb',0)
        this.activeLab = this.$store.state.activeLabMb
        // this.activeLab = 0
        this.productInfo = [...productInfo.miniInfo, ...productInfo.webInfo, ...productInfo.officeInfo, ...productInfo.saleInfo, ...productInfo.appInfo]
        this.backTop()
      },
      selectMini() {
        this.$store.commit('editActiveLabMb',1)
        this.activeLab = this.$store.state.activeLabMb
        // this.activeLab = 1
        this.productInfo = productInfo.miniInfo
        this.backTop()
      },
      selectWeb() {
        this.$store.commit('editActiveLabMb',2)
        this.activeLab = this.$store.state.activeLabMb
        // this.activeLab = 2
        this.productInfo = productInfo.webInfo
        this.backTop()
      },
      selectOffice() {
        this.$store.commit('editActiveLabMb',3)
        this.activeLab = this.$store.state.activeLabMb
        // this.activeLab = 3
        this.productInfo = productInfo.officeInfo
        this.backTop()
      },
      selectSale() {
        this.$store.commit('editActiveLabMb',4)
        this.activeLab = this.$store.state.activeLabMb
        // this.activeLab = 4
        this.productInfo = productInfo.saleInfo
        this.backTop()
      },
      selectApp() {
        this.$store.commit('editActiveLabMb',5)
        this.activeLab = this.$store.state.activeLabMb
        // this.activeLab = 5
        this.productInfo = productInfo.appInfo
        this.backTop()
      },*/
    }
  }
</script>

<style scoped>
  .class-label {
    position: fixed;
    top: 11vw;
    left: 0;
    /*display: flex;*/
    height: 12vw;
    /*padding: 0 2vw;*/
    background-color: #fff;
    /*margin-top: 12vw;*/
    /*width: 100%;*/
    box-shadow: 0 1px 0 #eee;
    justify-content: space-around;
    display: inline-block;
    white-space: nowrap;
  }

  .label-scroll {
    width: 100%;
    height: 12vw;
    overflow: hidden;
    touch-action: none;
  }

  .class-item {
    font-size: .875em;
    /*min-width: 25vw;*/
    text-align: center;
    padding: 3vw 5vw 1.2vw;
    display: inline-block;
  }

  .l--l {
    width: 3vw;
    height: 0;
    border: .5vw solid #6676e7;
    border-radius: 2em;
    margin: 1.3vw auto 0;
  }

  .pd-content {
    /*height: 200vh;*/
    background-color: #f5f5f5;
    display: flex;
    flex-direction: column;
    padding: 0 0 3.2vw;
    min-height: 60vh;
    margin-top: 11vw;
  }

  .pd-box {
    width: 93.6vw;
    /*height: 85.6vw;*/
    background-color: #fff;
    border-radius: 10px;
    margin: 3.2vw auto 0;
    display: inline-block;
    box-shadow: 0 0 5px #e3e3ed;
  }

  .pd-box:last-child {
    margin-bottom: 4vw;
  }

  .pd-box-top {
    padding: 4.5vw 3.2vw 4vw 4vw;
    display: flex;
    justify-content: space-between;
  }

  .pd-title {
    font-size: .94em;
    font-weight: bold;
  }

  .more-btn {
    width: 16vw;
    height: 6.4vw;
    background-color: #6676e7;
    border-radius: 2em;
    color: #fff;
    font-size: .625em;
    text-align: center;
    line-height: 6.4vw;
  }

  .more-btn p {
    /*margin-top: -1em;*/
  }

  .pd-intro {
    font-size: .75em;
    color: #768087;
    padding: 0 4vw;
    line-height: 160%;
    letter-spacing: .1em;
    display: -webkit-box;
    overflow: hidden;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .pd-pic img {
    width: 100%;
    height: 60vw;
    margin-top: 4.4vw;
    border-radius: 0 0 10px 10px;
  }
  .default-pic{
    background-color: #fff;
    height: 60vh;
    margin-top: 12vw;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .default-pic img{
    width: 60%;
    /*margin: auto;*/
  }
  .default-pic div{
    margin-top: 5vw;
    text-align: center;
    font-size: .75em;
    color: #768087;
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/mobile.vue